// extracted by mini-css-extract-plugin
export default {"main":"ReadOnlyChoiceMain_main__j3rEV"};